module.exports = __webpack_public_path__ + "img/view.1268b361.svg";